import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module14Nav = () => {
  const { module14 } = useSelector((state) => state.module14, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module14Images/JourneyMap14-01.png';
    const mobileImage =
      '/Module14Images/JourneyMap14-01_phone.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module14Images/Background14-01.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module9Images/Module9NavImages/JourneyMap_Mod4_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/solutions',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/solutions/solutions_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/respond_affirmation.mp4`,
      `userfiles/${module14.StudentID}/solutions_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/respond_affirmation.mp4`,
      `userfiles/${module14.StudentID}/solutions_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/respond_video_message.mp4`,
      `influencers/${login.influencerid3}/respond_affirmation.mp4`,
      `userfiles/${module14.StudentID}/solutions_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/respond_affirmation.mp4`
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE14'
          module={module14}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit3'
          nextDestiny='/unit3'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={3}
          animal={MediaService.getImage('/Images/Button_monkeyHead.png', login)}
        />
      )}
    </>
  );
};
export default Module14Nav;
